import React from "react";
import styled, { keyframes } from "styled-components";
import { colors } from "../../../../ui/theme/colors";

export const LoadingData = () => {
  return (
    <LoadingContainer>
      <SpinnerWrapper>
        <Spinner />
        <SpinnerInner />
      </SpinnerWrapper>
      <LoadingText>Loading Data...</LoadingText>
      <LoadingSubtext>
        Please wait while we fetch your information
      </LoadingSubtext>
    </LoadingContainer>
  );
};

// Animations
const spin = keyframes`
   0% {
      transform: rotate(0deg);
   }
   100% {
      transform: rotate(360deg);
   }
`;

const pulse = keyframes`
   0%, 100% {
      opacity: 1;
   }
   50% {
      opacity: 0.5;
   }
`;

const shimmer = keyframes`
   0% {
      background-position: -1000px 0;
   }
   100% {
      background-position: 1000px 0;
   }
`;

// Styled Components
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  padding: 40px 20px;
  width: 100%;
`;

const SpinnerWrapper = styled.div`
  position: relative;
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
`;

const Spinner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border: 4px solid rgba(44, 90, 160, 0.1);
  border-top: 4px solid ${colors.primary.main};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const SpinnerInner = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  bottom: 10px;
  border: 4px solid transparent;
  border-top: 4px solid ${colors.primary.light};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite reverse;
`;

const LoadingText = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: ${colors.neutral[700]};
  margin: 0 0 8px 0;
  animation: ${pulse} 2s ease-in-out infinite;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

const LoadingSubtext = styled.p`
  font-size: 14px;
  color: ${colors.neutral[500]};
  margin: 0;
  font-weight: 400;

  @media screen and (max-width: 768px) {
    font-size: 13px;
  }
`;
